import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {Observable, of} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';
import {AppState} from '../../reducers';
import {currentUser} from '../../selectors/auth.selectors';
import {
    USER_ROLE_CLIENT_ADMIN,
    USER_ROLE_CLIENT_NORMAL,
    USER_ROLE_PRODUCTION_ADMIN,
    USER_ROLE_SUUMO_ADMIN,
    USER_ROLE_SUUMO_CUSTOMER,
    USER_ROLE_SUUMO_NORMAL,
    UserModel
} from '../../models/user.model';

@Injectable()
export class ModuleGuard implements CanActivate {
    constructor(private store: Store<AppState>, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean>  {
        const moduleName = route.data.moduleName as string;
        if (!moduleName) {
            return of(false);
        }
        return this.store.pipe(select(currentUser),
            map((user: UserModel) => {
                if (user) {
                    if (moduleName === 'TeamManagementModule') {
                        return user.role === USER_ROLE_PRODUCTION_ADMIN;
                    } else if (moduleName === 'SystemManagementModule') {
                        return user.role === USER_ROLE_PRODUCTION_ADMIN;
                    } else if (moduleName === 'SpaceManagementModule') {
                        return user.role === USER_ROLE_CLIENT_ADMIN ||
                            user.role === USER_ROLE_CLIENT_NORMAL ||
                            user.role === USER_ROLE_SUUMO_ADMIN ||
                            user.role === USER_ROLE_SUUMO_NORMAL;
                    } else if (moduleName === 'WizardManagementModule') {
                        return user.role === USER_ROLE_CLIENT_ADMIN ||
                            user.role === USER_ROLE_CLIENT_NORMAL ||
                            user.role === USER_ROLE_PRODUCTION_ADMIN ||
                            user.role === USER_ROLE_SUUMO_ADMIN ||
                            user.role === USER_ROLE_SUUMO_NORMAL;
                    } else if (moduleName === 'ScheduleComponent') {
                        return user.role === 1 ||
                            user.role === 2 ||
                            user.role === 5 ||
                            user.role === USER_ROLE_SUUMO_ADMIN ||
                            user.role === USER_ROLE_SUUMO_NORMAL ||
                            user.role === USER_ROLE_SUUMO_CUSTOMER;
                    } else if (moduleName === 'GanttChartComponent') {
                        return user.role === 3 || user.role === 4;
                    } else if (moduleName === 'DirectChatManagementModule') {
                        return user.role === 3 || user.role === 4 || user.role === 5;
                    }
                }
                return false;
            }),
            tap(hasAccess => {
                if (!hasAccess) {
                    this.router.navigateByUrl('/dashboard');
                }
            })
        );
    }
}
